export class MonthListRequest {

    _year = undefined; // number

    setYear(year) {
        this._year = year;
    }

    body() {
        return {
            criteria: {
                construction_id: undefined,
                year: this._year,
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/webservices/month-list/MonthListRequest.js